import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import clsx from 'clsx';
import Link from '../Link';
import styles from './ListDefinitionRejectionDialog.style';

const ListDefinitionRejectionDialog = ({
  onDismiss,
  onSubmit,
  className,
  text,
  href,
  isDuplicateName,
  ...other
}) => (
  <Dialog
    dialogContentProps={{
      type: DialogType.normal,
      title: 'List cannot be saved',
      closeButtonAriaLabel: 'Close',
    }}
    modalProps={{
      className: clsx(styles.root, className),
    }}
    onDismiss={onDismiss}
    onSubmit={onSubmit}
    {...other}
  >
    <div className={styles.modalText}>
      {isDuplicateName ? (
        <>
          {' '}
          <p>
            Cannot save the list due to a duplicate list name found in{' '}
            <Link target="_blank" href={href}>
              {text}
            </Link>
            . Change list name to save.
          </p>
        </>
      ) : (
        <>
          {' '}
          <p>
            Cannot save the list due to existing matching list definition found in{' '}
            <Link target="_blank" href={href}>
              {text}
            </Link>
            . Add or remove items or nested lists in order to save.
          </p>
        </>
      )}
    </div>
    <DialogFooter>
      <PrimaryButton onClick={onSubmit}>Continue Editing</PrimaryButton>
    </DialogFooter>
  </Dialog>
);

ListDefinitionRejectionDialog.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  text: PropTypes.string,
  href: PropTypes.string,
  isDuplicateName: PropTypes.bool,
  className: PropTypes.string,
};

ListDefinitionRejectionDialog.defaultProps = {
  text: '',
  href: '',
  isDuplicateName: true,
  className: 'normal',
};

export default ListDefinitionRejectionDialog;
